export type LoginWelcomeInput = {
  email: string;
  firstName?: string | null;
  roles?: string[] | undefined;
  profilePictureUrl?: string | null;
};

function getTimeGreeting(now = new Date()): string {
  const hour = now.getHours();
  if (hour >= 18) return 'Bonsoir';
  if (hour >= 12) return 'Bon après-midi';
  return 'Bonjour';
}

function displayNameFromIdentity({ email, firstName }: LoginWelcomeInput): string {
  const trimmed = firstName?.trim();
  if (trimmed) return trimmed;
  const local = email.split('@')[0]?.trim();
  if (!local) return email;
  return local.charAt(0).toUpperCase() + local.slice(1);
}

export function buildLoginWelcome(identity: LoginWelcomeInput, now = new Date()) {
  const displayName = displayNameFromIdentity(identity);
  const greetingLead = getTimeGreeting(now);
  const greeting = `${greetingLead}, ${displayName}`;
  return { greeting, greetingLead, emphasizedName: displayName, displayName };
}
